import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import Chip, { ChipsList } from '@clds/chip';
import { RecipeComplexity } from '../../types';
import { ComplexityTag } from '../ComplexityTag/ComplexityTag';

export interface RecipeTagsProps {
  /** Recipe tags, will be displayed as chips */
  tags?: string[];
  /** Recipe complexity level, will be displayed as Chip with icon */
  complexity?: RecipeComplexity;
}

const StyledChipsList = styled(ChipsList)`
  margin-bottom: ${globalTheme.spacing.md};
`;

/**
 * Used to display cookbook recipe tags and complexity level
 */
export const RecipeTags: FC<React.PropsWithChildren<RecipeTagsProps>> = ({ tags, complexity }) => (
  <StyledChipsList data-test="tags">
    {tags?.map((tag) => <Chip key={tag} label={tag} />)}
    {complexity && <ComplexityTag complexity={complexity} />}
  </StyledChipsList>
);
